import React from 'react';
import { Form, Row, Col, Dropdown } from 'react-bootstrap';
import styles from '../AddProducts.module.scss';

const ClientSelect = ({
    clients,
    value,
    onChange,
    error,
    edit,
    loading,
    searchType,
    setSearchType,
    searchTerm,
    setSearchTerm
}) => {

    const handleClientSelect = (clientId) => {
        const selected = clientId ? clients.find(client => String(client.id) === String(clientId)) : null;
        onChange({
            target: {
                name: 'clientId',
                value: clientId,
                client: selected ? selected.name : ''
            }
        });
    };

    return (
        <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm={3}>
                Client
            </Form.Label>
            <Col sm={9}>
                <Dropdown
                    className="w-100"
                    onToggle={(nextShow) => {
                        // When the dropdown closes, clear the parent's search term
                        if (!nextShow && typeof setSearchTerm === 'function') {
                            setSearchTerm('');
                        }
                    }}
                >
                    <Dropdown.Toggle
                        variant='light'
                        className={`form-select text-start ${styles.noCaret} w-100 ${error ? 'is-invalid' : ''}`}
                        id='client-select'
                        disabled={loading}
                    >
                        {(() => {
                            if (value) {
                                const selected = clients.find(client => String(client.id) === String(value));
                                return selected ? selected.name : 'Select a Client';
                            }
                            return 'Select a Client';
                        })()}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.dropdownMenu}>
                        <div className={styles.searchContainer}>
                            <div className="d-flex gap-2">
                                {setSearchType && (
                                    <Form.Control
                                        size='sm'
                                        as="select"
                                        className='form-select'
                                        value={searchType || 'name'}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setSearchType(val);
                                        }}
                                        style={{ width: 'auto' }}
                                    >
                                        <option value="name">Name</option>
                                    </Form.Control>
                                )}
                                {setSearchTerm && (
                                    <Form.Control
                                        size='sm'
                                        type='text'
                                        placeholder='Search clients...'
                                        value={searchTerm || ''}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setSearchTerm(val);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                        <div className={styles.scrollableMenu}>
                            {clients.length === 0 && !loading && (
                                <div className={styles.noMatches}>No clients found</div>
                            )}
                            {loading ? (
                                <div className={styles.noMatches}>Loading clients...</div>
                            ) : (
                                <>
                                    {!(searchTerm && String(searchTerm).trim() !== '') && (
                                        <Dropdown.Item
                                            key="none"
                                            active={!value}
                                            onClick={() => handleClientSelect('')}
                                        >
                                            Select a Client
                                        </Dropdown.Item>
                                    )}
                                    {clients.map((client) => (
                                        <Dropdown.Item
                                            key={client.id}
                                            active={String(value) === String(client.id)}
                                            onClick={() => handleClientSelect(client.id)}
                                        >
                                            {client.name} (ID: {client.id})
                                        </Dropdown.Item>
                                    ))}
                                </>
                            )}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
                {error && (
                    <div className="invalid-feedback">
                        {error}
                    </div>
                )}
            </Col>
        </Form.Group>
    )

};

export default ClientSelect;